import clsx from 'clsx';

const sizes = {
  sm: 'tw:h-4 tw:w-4 tw:border-2',
  md: 'tw:h-6 tw:w-6 tw:border-2',
  lg: 'tw:h-8 tw:w-8 tw:border-2',
  xl: 'tw:h-12 tw:w-12 tw:border-4',
};

const variants = {
  brand: 'tw:border-zinc-300 tw:border-t-brand-green-0',
  zinc: 'tw:border-zinc-300 tw:border-t-zinc-600',
  white: 'tw:border-white tw:border-t-transparent',
};

export function Spinner({
  size = 'lg',
  variant = 'brand',
  label,
  className,
  ...props
}: {
  size?: keyof typeof sizes;
  variant?: keyof typeof variants;
  label?: string;
} & React.ComponentPropsWithoutRef<'div'>) {
  const circle = (
    <div
      aria-label={label ?? 'Loading'}
      role="status"
      {...props}
      className={clsx(
        'tw:animate-spin tw:rounded-full',
        sizes[size],
        variants[variant],
        !label && className
      )}
    />
  );

  if (!label) return circle;

  return (
    <div className={clsx('tw:flex tw:flex-col tw:items-center tw:gap-3', className)}>
      {circle}
      <p className="tw:text-sm tw:text-zinc-500">{label}</p>
    </div>
  );
}
